import React from "react";
import PropTypes from "prop-types";
import { withFormik, Field } from "formik";
import { useTranslation } from "react-i18next";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "./relief.data.form";
import InputTextarea from "../../../utils/InputTextarea";
import { ButtonClose } from "../reliefList/reliefList.styled";
import { useDispatch } from "react-redux";
import { hide } from "redux-modal";

const ReliefForm = (props) => {
  const { t } = useTranslation();
  const { handleSubmit} = props;
  const dispatch = useDispatch();
  const handlerClosePopup = (popupName) => {
    dispatch(hide(popupName));
  };

  return (
    <>
      <div className="row justify-content-center">
        <div className="row mb-3">
          <div className="col-12 text-end">
            <ButtonClose
              type="button"
              onClick={() => handlerClosePopup("ModalForm")}
            >
              <i className="fa-solid fa-xmark"></i>
            </ButtonClose>
          </div>
        </div>
        <div className="col-12 col-md-11">
          <h3 className="title">{t(`forms.turnHistory.relief`)}</h3>
        </div>
      </div>
      <div className="row justify-content-center ">
        <div className="col-12 col-md-11 marg-btm-1rem">
          <p>{t(`forms.turnHistory.reliefText`)}</p>
        </div>
      </div>
      <div className="row justify-content-center ">
        <div className="col-12 col-md-11">
          <form onSubmit={handleSubmit} autoComplete="off">
            <div className="row">
              <div className="col-12 mt-2">
                <Field
                  id="observations"
                  className="form-control"
                  labelField={t("forms.turnHistory.labels.observations")}
                  name="observations"
                  component={InputTextarea}
                  fieldType="text"
                  placeholder=""
                  mandatory
                />
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-10 col-sm-11 text-center mt-5 mb-5">
                <button type="submit" className="btn btn-lg btn-primary">
                  {t(`forms.turnHistory.buttons.save`)}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

ReliefForm.propTypes = {
  handleSubmit: PropTypes.func,
  cancelAction: PropTypes.func,
};

const ReliefFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return {
      ...dataModel,
      observations: props.observations || "",
    };
  },
  validationSchema: (props) => {
    return validationDataModel(props.edit);
  },
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values, resetForm);
  },
  enableReinitialize: true,
  displayName: "ReliefForm",
})(ReliefForm);

export default ReliefFormF;
